import React, { useState } from 'react'
import PropTypes from 'prop-types'
import SmileIcon from 'src/assets/icons/smile.svg'
import FeedbackFormDirectButton from './FeedbackFormDirectButton'
import FeedbackFormOptionButtons from './FeedbackFormOptionButtons'
import FeedbackFormMailToButton from './FeedbackFormMailToButton'

let dataLayer

if (typeof window !== `undefined`) {
  dataLayer = window.dataLayer
}

const propTypes = {
  urlForm: PropTypes.string,
  formTitle: PropTypes.string,
  formType: PropTypes.string,
  formCategory: PropTypes.string,
}

const FeedbackFormLink = props => {
  const [selected, setSelected] = useState('')

  const { formCategory, urlForm, formTitle, formType } = props

  let faqDataLayer = formCategory + ' - ' + formTitle

  function setNeedHelp() {
    setSelected('positive')
    if (dataLayer && dataLayer.push) {
      dataLayer.push({
        event: 'feedback',
        faq: faqDataLayer,
        feedbackType: 'yes',
      })
    }
  }

  function setImGood() {
    setSelected('negative')
    if (dataLayer && dataLayer.push) {
      dataLayer.push({
        event: 'feedback',
        faq: faqDataLayer,
        feedbackType: 'no',
      })
    }
  }

  return (
    <article className="flex flex-wrap items-start justify-between pt-4 mt-3 border border-b-0 border-l-0 border-r-0 border-black-25">
      {/* OLD CODE FOR McColls FAQS - To link to old MailTo code */}
      {/* {urlForm && urlForm === '/mccolls/' && formType && formType === 'info' && (
        <div className="w-full pb-4 border border-t-0 border-l-0 border-r-0 border-black-25">
          <FeedbackFormMailToButton
            mailtoTitle={formTitle}
            emailAddress={'cservice@mccolls.co.uk'}
            mailtoType={'McColls'}
          />
        </div>
      )} */}
      {/* CODE FOR CASE FAQS */}
      {formType && formType === 'case' && (
        <div className="w-full pb-6 border border-t-0 border-l-0 border-r-0 border-black-25">
          <FeedbackFormDirectButton formTitle={formTitle} urlForm={urlForm} />
        </div>
      )}
      {/* CODE FOR CALL FAQS */}
      {formType && formType === 'call' && (
        <>
          <section className="mx-auto sm:mx-0 sm:pr-4">
            <div className="w-full mb-1 sm:w-auto">
              <h4 className="text-lg font-semibold text-center sm:text-left">
                Do you still require help to answer your question?
              </h4>
            </div>
            {selected !== 'positive' && selected !== 'negative' && (
              <div className="w-full mb-4 sm:mb-0 sm:w-auto ">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Click yes to contact us
                </p>
              </div>
            )}
            {selected === 'positive' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Select how you would like to contact us below
                </p>
              </div>
            )}
            {selected === 'negative' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Thank you, your feedback is important
                </p>
              </div>
            )}
          </section>

          <section className="flex justify-center w-full mb-4 sm:w-auto">
            <button
              className={`px-8 py-3 mx-4 text-center rounded-lg sm:px-6 transition-fast bg-secondary hover:bg-secondary-dark ${selected ===
                'negative' && 'opacity-25'} ${selected === 'positive' &&
                'pointer-events-none'}`}
              onClick={setNeedHelp}
            >
              <span className="font-semibold text-white whitespace-no-wrap">
                Yes
              </span>
            </button>
            <button
              className={`px-8 py-3 text-center rounded-lg sm:px-6 bg-secondary hover:bg-secondary-dark ${selected ===
                'positive' && 'opacity-25'} ${selected === 'negative' &&
                'pointer-events-none'}`}
              onClick={setImGood}
            >
              {selected !== 'negative' && (
                <span className="font-semibold text-white whitespace-no-wrap">
                  No
                </span>
              )}
              {selected === 'negative' && (
                <div className="flex text-white">
                  <SmileIcon className="self-stretch flex-1 h-full" />
                </div>
              )}
            </button>
          </section>
          {selected !== 'positive' && (
            <div className="w-full border border-t-0 border-l-0 border-r-0 border-black-25"></div>
          )}
          {selected === 'positive' && (
            <div
              className={`w-full transition-fast h-0 overflow-hidden flex justify-center flex-wrap ${selected &&
                'h-auto'}`}
            >
              {urlForm && (
                <FeedbackFormDirectButton
                  formTitle={formTitle}
                  urlForm={urlForm}
                />
              )}
              <FeedbackFormOptionButtons
                formCategory={formCategory}
                urlForm={urlForm}
                formType={formType}
              />
            </div>
          )}
        </>
      )}
      {/* CODE FOR CALL ONLY (NO FORMS) FAQS */}
      {formType && formType === 'callonly' && (
        <>
          <section className="mx-auto sm:mx-0 sm:pr-4">
            <div className="w-full mb-1 sm:w-auto">
              <h4 className="text-lg font-semibold text-center sm:text-left">
                Do you still require help to answer your question?
              </h4>
            </div>
            {selected !== 'positive' && selected !== 'negative' && (
              <div className="w-full mb-4 sm:mb-0 sm:w-auto ">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Click yes to contact us
                </p>
              </div>
            )}
            {selected === 'positive' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Select how you would like to contact us below
                </p>
              </div>
            )}
            {selected === 'negative' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Thank you, your feedback is important
                </p>
              </div>
            )}
          </section>

          <section className="flex justify-center w-full mb-4 sm:w-auto">
            <button
              className={`px-8 py-3 mx-4 text-center rounded-lg sm:px-6 transition-fast bg-secondary hover:bg-secondary-dark ${selected ===
                'negative' && 'opacity-25'} ${selected === 'positive' &&
                'pointer-events-none'}`}
              onClick={setNeedHelp}
            >
              <span className="font-semibold text-white whitespace-no-wrap">
                Yes
              </span>
            </button>
            <button
              className={`px-8 py-3 text-center rounded-lg sm:px-6 bg-secondary hover:bg-secondary-dark ${selected ===
                'positive' && 'opacity-25'} ${selected === 'negative' &&
                'pointer-events-none'}`}
              onClick={setImGood}
            >
              {selected !== 'negative' && (
                <span className="font-semibold text-white whitespace-no-wrap">
                  No
                </span>
              )}
              {selected === 'negative' && (
                <div className="flex text-white">
                  <SmileIcon className="self-stretch flex-1 h-full" />
                </div>
              )}
            </button>
          </section>
          {selected !== 'positive' && (
            <div className="w-full border border-t-0 border-l-0 border-r-0 border-black-25"></div>
          )}
          {selected === 'positive' && (
            <div
              className={`w-full transition-fast h-0 overflow-hidden flex justify-center flex-wrap ${selected &&
                'h-auto'}`}
            >
              <FeedbackFormOptionButtons
                formCategory={formCategory}
                urlForm={urlForm}
                formType={formType}
              />
            </div>
          )}
        </>
      )}
      {/* CODE FOR INFO FAQS */}
      {urlForm && urlForm !== '/mccolls/' && formType && formType === 'info' && (
        <>
          <section className="mx-auto sm:mx-0 sm:pr-4">
            <div className="w-full mb-1 sm:w-auto">
              <h4 className="text-lg font-semibold text-center sm:text-left">
                Do you still require help to answer your question?
              </h4>
            </div>
            {selected !== 'positive' && selected !== 'negative' && (
              <div className="w-full mb-4 sm:mb-0 sm:w-auto ">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Click yes to contact us
                </p>
              </div>
            )}
            {selected === 'positive' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Select how you would like to contact us below
                </p>
              </div>
            )}
            {selected === 'negative' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Thank you, your feedback is important
                </p>
              </div>
            )}
          </section>

          <section className="flex justify-center w-full mb-4 sm:w-auto">
            <button
              className={`px-8 py-3 mx-4 text-center rounded-lg sm:px-6 transition-fast bg-secondary hover:bg-secondary-dark ${selected ===
                'negative' && 'opacity-25'} ${selected === 'positive' &&
                'pointer-events-none'}`}
              onClick={setNeedHelp}
            >
              <span className="font-semibold text-white whitespace-no-wrap">
                Yes
              </span>
            </button>
            <button
              className={`px-8 py-3 text-center rounded-lg sm:px-6 bg-secondary hover:bg-secondary-dark ${selected ===
                'positive' && 'opacity-25'} ${selected === 'negative' &&
                'pointer-events-none'}`}
              onClick={setImGood}
            >
              {selected !== 'negative' && (
                <span className="font-semibold text-white whitespace-no-wrap">
                  No
                </span>
              )}
              {selected === 'negative' && (
                <div className="flex text-white">
                  <SmileIcon className="self-stretch flex-1 h-full" />
                </div>
              )}
            </button>
          </section>
          {selected !== 'positive' && (
            <div className="w-full border border-t-0 border-l-0 border-r-0 border-black-25"></div>
          )}
          {selected === 'positive' && (
            <div
              className={`w-full transition-fast h-0 overflow-hidden flex justify-center flex-wrap ${selected &&
                'h-auto border-b pb-6 border-black-25'}`}
            >
              {urlForm && (
                <FeedbackFormDirectButton
                  formTitle={formTitle}
                  urlForm={urlForm}
                />
              )}
              <FeedbackFormOptionButtons
                formCategory={formCategory}
                urlForm={urlForm}
              />
            </div>
          )}
        </>
      )}
      {/* CODE FOR LIVE CHAT FAQS */}
      {formType === 'livechat' && (
        <>
          <section className="mx-auto sm:mx-0 sm:pr-4">
            <div className="w-full mb-1 sm:w-auto">
              <h4 className="text-lg font-semibold text-center sm:text-left">
                Do you still require help to answer your question?
              </h4>
            </div>
            {selected !== 'positive' && selected !== 'negative' && (
              <div className="w-full mb-4 sm:mb-0 sm:w-auto ">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Click yes to contact us
                </p>
              </div>
            )}
            {selected === 'positive' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Select how you would like to contact us below
                </p>
              </div>
            )}
            {selected === 'negative' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Thank you, your feedback is important
                </p>
              </div>
            )}
          </section>

          <section className="flex justify-center w-full mb-4 sm:w-auto">
            <button
              className={`px-8 py-3 mx-4 text-center rounded-lg sm:px-6 transition-fast bg-secondary hover:bg-secondary-dark ${selected ===
                'negative' && 'opacity-25'} ${selected === 'positive' &&
                'pointer-events-none'}`}
              onClick={setNeedHelp}
            >
              <span className="font-semibold text-white whitespace-no-wrap">
                Yes
              </span>
            </button>
            <button
              className={`px-8 py-3 text-center rounded-lg sm:px-6 bg-secondary hover:bg-secondary-dark ${selected ===
                'positive' && 'opacity-25'} ${selected === 'negative' &&
                'pointer-events-none'}`}
              onClick={setImGood}
            >
              {selected !== 'negative' && (
                <span className="font-semibold text-white whitespace-no-wrap">
                  No
                </span>
              )}
              {selected === 'negative' && (
                <div className="flex text-white">
                  <SmileIcon className="self-stretch flex-1 h-full" />
                </div>
              )}
            </button>
          </section>
          {selected !== 'positive' && (
            <div className="w-full border border-t-0 border-l-0 border-r-0 border-black-25"></div>
          )}
          {selected === 'positive' && (
            <div
              className={`w-full transition-fast h-0 overflow-hidden flex justify-center flex-wrap ${selected &&
                'h-auto'}`}
            >
              {urlForm && (
                <FeedbackFormDirectButton
                  formTitle={formTitle}
                  urlForm={urlForm}
                />
              )}
              <FeedbackFormOptionButtons
                formCategory={formCategory}
                urlForm={urlForm}
                formType={formType}
              />
            </div>
          )}
        </>
      )}
      {/* CODE FOR UNDEFINED FAQS */}
      {formType == null && (
        <>
          <section className="mx-auto sm:mx-0 sm:pr-4">
            <div className="w-full mb-1 sm:w-auto">
              <h4 className="text-lg font-semibold text-center sm:text-left">
                Do you still require help to answer your question?
              </h4>
            </div>
            {selected !== 'positive' && selected !== 'negative' && (
              <div className="w-full mb-4 sm:mb-0 sm:w-auto ">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Click yes to contact us
                </p>
              </div>
            )}
            {selected === 'positive' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Select how you would like to contact us below
                </p>
              </div>
            )}
            {selected === 'negative' && (
              <div className="mb-4">
                <p className="font-medium text-center text-body-light sm:text-left">
                  Thank you, your feedback is important
                </p>
              </div>
            )}
          </section>

          <section className="flex justify-center w-full mb-4 sm:w-auto">
            <button
              className={`px-8 py-3 mx-4 text-center rounded-lg sm:px-6 transition-fast bg-secondary hover:bg-secondary-dark ${selected ===
                'negative' && 'opacity-25'} ${selected === 'positive' &&
                'pointer-events-none'}`}
              onClick={setNeedHelp}
            >
              <span className="font-semibold text-white whitespace-no-wrap">
                Yes
              </span>
            </button>
            <button
              className={`px-8 py-3 text-center rounded-lg sm:px-6 bg-secondary hover:bg-secondary-dark ${selected ===
                'positive' && 'opacity-25'} ${selected === 'negative' &&
                'pointer-events-none'}`}
              onClick={setImGood}
            >
              {selected !== 'negative' && (
                <span className="font-semibold text-white whitespace-no-wrap">
                  No
                </span>
              )}
              {selected === 'negative' && (
                <div className="flex text-white">
                  <SmileIcon className="self-stretch flex-1 h-full" />
                </div>
              )}
            </button>
          </section>
          {selected !== 'positive' && (
            <div className="w-full border border-t-0 border-l-0 border-r-0 border-black-25"></div>
          )}
          {selected === 'positive' && (
            <div
              className={`w-full transition-fast h-0 overflow-hidden flex justify-center flex-wrap ${selected &&
                'h-auto'}`}
            >
              {urlForm && (
                <FeedbackFormDirectButton
                  formTitle={formTitle}
                  urlForm={urlForm}
                />
              )}
              <FeedbackFormOptionButtons
                formCategory={formCategory}
                urlForm={urlForm}
              />
            </div>
          )}
        </>
      )}
    </article>
  )
}

FeedbackFormLink.propTypes = propTypes

export default FeedbackFormLink
